<template>
  <div v-if="item">
    <modalWindow v-model="showModel" @ok="createSubmit()" @cancel="cancel()" title="Editácia oblasti" @closed="onClose()" :cancelText="'Zrušïť'" :okText="'Uložiť'">
      <form>
        <text-field field-id="label"
                    label="Názov"
                    placeholder="Zadaj názov"
                    v-model="item.label"
                    :maxlength="100"
                    validation="required|min:3|max:100"></text-field>
        <text-field field-id="shortDescription"
                    label="Popis"
                    placeholder="Zadaj popis"
                    v-model="item.shortDescription"
                    :maxlength="200"
                    validation="required|min:3|max:200"></text-field>
      </form>
    </modalWindow>
  </div>
</template>

<script>
  import codeListCreateModalMixin from './codeListCreateModalMixin';

  export default {
      mixins: [codeListCreateModalMixin]
  }
</script>



// WEBPACK FOOTER //
// client/components/codeListCreateModalGeneric.vue